export default __webpack_public_path__ + "static/media/banner.1746e00f.png";